/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2024 - All Rights Reserved
###################################################################
*/

function handleInitialAdjustments({
    questionnaire,
    setFieldValue,
    personData
}) {
    try {
        return questionnaire.map(question => {
            if (question.idQuestion === 2180) {
                question.answer = personData.lastName;
                question.answerJson =  personData.lastName;
            }
            return question;
        })
    } catch (e) {
        console.log("ENTITY INFORMATION- handleInitialAdjustments error", e);
    }
}

const events = {
    handleInitialAdjustments
};

export { events };